/* eslint-disable react-hooks/exhaustive-deps */
import { Col, Descriptions, Row, Typography } from "antd";
import CustomDescriptions from "components/CustomDescriptions";
import Card from "features/Cart/components/Card";
import { TitleCard } from "features/Serial/components/TitleCard";
import { Link } from "react-router-dom";
import moment from "moment";
import "./index.scss";

const Info = ({ dataDetail, refetch, isSupplier }) => {
  const typeMap = {
    FRAMEWORK_AGREEMENT: "Hợp đồng nguyên tắc",
    PURCHASE_AGREEMENT: "Hợp đồng mua bán",
  };

  const statusMap = {
    ACTIVE: { text: "Còn hiệu lực", className: "status-true" },
    EXPIRED: { text: "Hết hạn", className: "status-warning" },
    DISABLED: { text: "Vô hiệu hóa", className: "status-false" },
  };

  const statusInfo = statusMap[dataDetail?.status] || { text: dataDetail?.status, className: "status-false" };

  return (
    <>
      <Row
        gutter={[16, 16]}
        className="card-title-detail-seller-supplier padding hr"
        justify={"space-between"}
        align={"middle"}
      >
        <Col span={16}>
          <Row gutter={[16, 16]} align="middle" style={{ gap: "24px" }}>
            <span className="title">
              {dataDetail?.code} {dataDetail?.seller?.fullName ? `- ${dataDetail.seller.fullName}` : ""}
            </span>
            <span className={statusInfo.className}>{statusInfo.text}</span>
          </Row>
        </Col>
      </Row>
      <div>
        <Card title={<TitleCard title="Thông tin chung" />}>
          <Col span={24} style={{ padding: "0 12px", marginBottom: "100px" }}>
            <Row gutter={[24, 16]}>
              <Col span={12}>
                <CustomDescriptions
                  content={
                    <>
                      <Descriptions.Item label={"Mã hợp đồng"}>
                        <Typography.Text>{dataDetail?.code || "-"}</Typography.Text>
                      </Descriptions.Item>
                      <Descriptions.Item label={"Đại lý"}>
                        {dataDetail?.seller?.id ? (
                          <Typography.Link
                            strong
                            onClick={(e) => {
                              e.preventDefault();
                              window.open(`/seller/detail/${dataDetail.seller.id}?tab=GENERAL_INFO`, "_blank");
                            }}
                          >
                            {dataDetail.seller.fullName || "-"}
                          </Typography.Link>
                        ) : (
                          <Typography.Text>-</Typography.Text>
                        )}
                      </Descriptions.Item>
                      <Descriptions.Item label={"Loại hợp đồng"}>
                        {typeMap[dataDetail?.type] || dataDetail?.type || "-"}
                      </Descriptions.Item>
                      <Descriptions.Item label={"Người tạo trên hệ thống"}>
                        <Typography.Text>{dataDetail?.createdBy?.fullname || "-"}</Typography.Text>
                      </Descriptions.Item>
                    </>
                  }
                />
              </Col>
              <Col span={12}>
                <CustomDescriptions
                  content={
                    <>
                      <Descriptions.Item label={"Ngày ký"}>
                        <Typography.Text>
                          {dataDetail?.startDate ? moment(dataDetail.startDate).format("DD/MM/YYYY") : "-"}
                        </Typography.Text>
                      </Descriptions.Item>
                      <Descriptions.Item label={"Hết hạn"}>
                        <Typography.Text>
                          {dataDetail?.endDate ? moment(dataDetail.endDate).format("DD/MM/YYYY") : "-"}
                        </Typography.Text>
                      </Descriptions.Item>
                      <Descriptions.Item label={"Người lập hợp đồng"}>
                        <Typography.Text>{dataDetail?.drafterBy?.fullname || "-"}</Typography.Text>
                      </Descriptions.Item>
                      <Descriptions.Item label={"Ngày tạo trên hệ thống"}>
                        <Typography.Text>
                          {dataDetail?.createdAt ? moment(dataDetail.createdAt).format("DD/MM/YYYY") : "-"}
                        </Typography.Text>
                      </Descriptions.Item>
                    </>
                  }
                />
              </Col>
            </Row>
          </Col>
        </Card>
        <div style={{ marginTop: "16px" }}>
          <Card title={<TitleCard title="Mô tả" />} style={{ padding: "0 12px", marginBottom: "100px" }}>
            <Typography.Text>Ghi chú : {dataDetail?.note || "Không có ghi chú"}</Typography.Text>
            <div style={{ marginTop: "16px" }}>
              {dataDetail?.fileURL ? (
                <div
                  style={{
                    border: "1px dashed #d9d9d9",
                    borderRadius: "2px",
                    background: "#fafafa",
                    padding: "16px",
                  }}
                >
                  <iframe
                    src={dataDetail.fileURL}
                    style={{
                      width: "100%",
                      height: "842px",
                      border: "none",
                    }}
                    title="Contract PDF Preview"
                  />
                </div>
              ) : (
                <Typography.Text type="secondary">Không có file hợp đồng</Typography.Text>
              )}
            </div>
          </Card>
        </div>
      </div>
    </>
  );
};

export default Info;
